export function useRedirectCookie() {
  return useCookie(REDIRECT_COOKIE_NAME, {
    ...AUTH_COOKIE_OPTIONS,
    httpOnly: false,
  })
}
